// Footer.tsx
import { FC } from "react";
import { useData } from "../../context/DataProvider";
import ErrorModal from "../Error/Error";
import Loading from "../Loading/Loading";
import styles from "./Footer.module.scss";

const Footer: FC = () => {
  const { iletisimBilgileri: contactData, isLoading, error } = useData();

  if (isLoading) return <Loading />;
  if (error) return <ErrorModal message={error.message} />;

  // Instagram ve Twitter kullanıcı adlarını al
  const getUsername = (url: string | undefined) => {
    if (!url) return "";
    const parts = url.split("/");
    return "@" + parts[parts.length - 1];
  };

  return (
    <div className={styles.footer}>
      {/* Sol kısım (Harita) */}
      <div className={styles.leftSection}>
        {/* Harita iframe'i */}
        <div
          className={styles.mapArea}
          dangerouslySetInnerHTML={{ __html: contactData?.haritaUrl || "" }}
        ></div>
      </div>

      {/* Sağ kısım */}
      <div className={styles.rightSection}>
        {/* Adres alanı */}
        <div className={styles.addressArea}>
          {/* Örnek adres metni, istediğiniz şekilde değiştirebilirsiniz */}
          <p>{contactData?.adres}</p>
        </div>

        {/* Sosyal medya alanı */}
        <div className={styles.socialArea}>
          {/* Sosyal medya item 1 */}
          {contactData?.instagram && (
            <div className={styles.socialItem}>
              <img
                src="/assets/insta-footer.png"
                alt="Instagram"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  window.open(contactData.instagram, "_blank");
                }}
              />
              <span
                style={{ cursor: "pointer" }}
                onClick={() => {
                  window.open(contactData.instagram, "_blank");
                }}
              >
                {getUsername(contactData.instagram)}
              </span>
            </div>
          )}

          {/* Sosyal medya item 2 */}
          {contactData?.twitter && (
            <div className={styles.socialItem}>
              <img
                src="/assets/x-footer.png"
                alt="Twitter"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  window.open(contactData.twitter, "_blank");
                }}
              />
              <span
                style={{ cursor: "pointer" }}
                onClick={() => {
                  window.open(contactData.twitter, "_blank");
                }}
              >
                {getUsername(contactData.twitter)}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Footer;
